module.exports = __webpack_public_path__ + "static/img/tgl-login-logo.d28f7181.png";